module.exports = __webpack_public_path__ + "img/history.1ab84836.jpg";